import {Avatar} from 'antd'
import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import React from 'react'
import {Link} from 'react-router-dom'
import {AppEntities} from 'views/AppLocals/enums'
import useTranslate from '../../modules/local/useTranslate'
import {renderIf} from '../../views/Shared'
import {SearchGroupIcon} from '../AppIcon'
import ImageLoader from '../ImageLoader'
import './BaseItem.scss'
import TooltipApp from "components/TooltipApp";

export const BaseItem = React.memo(
  ({
     to,
     avatar,
     cover,
     type,
     premium,
     description,
     verified,
     className,
     horizontal,
     style,
     children,
     ...item
   }) => {
    const t = useTranslate()
    const ItemLink = to ? Link : 'div'
    return (
      <div
        style={{
          maxWidth: 300,
          ...(style ?? {}),
        }}
        className={classNames(
          'flex flex-col background rounded-md shadow-md relative',
          className
        )}>
        {renderIf(
          cover,
          <ImageLoader
            style={{width: 200, height: 100}}
            className="rounded-t-md object-cover"
            src={cover}
          />
        )}
        <div className="flex flex-col gap-2 p-2">
          <div className="flex items-center gap-2">
            <Avatar
              size={30}
              className={classNames(
                'flex flex-center background-200',
                type === AppEntities.USER ? 'rounded-full' : 'rounded-md'
              )}
              icon={
                <SearchGroupIcon
                  size={16}
                  type={type}
                  className="text-color-400"
                />
              }
              src={avatar}
            />
            <TooltipApp title={getTitle(item)}>
              <div className="flex flex-col flex-1 truncate">
                <ItemLink
                  to={to}
                  target="_blank"
                  className="font-bold text-sm text-color-000 leading-tight truncate">
                  {getTitle(item)}
                </ItemLink>
                <span className="text-2xs text-green-600 italic">
                  {t(type)}
                </span>
              </div>
            </TooltipApp>
          </div>
          {renderIf(
            description,
            <div className="text-xs text-color-300 italic">{description}</div>
          )}
          {children}
        </div>
      </div>
    )
  }
)
